<template>
  <div class="api-result">
    <div v-if="results && results.length" class="results">
      <hr>
      <slot></slot>
    </div>
    <div v-else-if="loading" class="loading"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i></div>
    <p v-else-if="response" class="no-results text-danger lead">No results found</p>
    <hr>
  </div>
</template>


<script>
export default {
  name: 'api-result',
  props: ['results', 'response', 'loading']
}
</script>


<style scoped>
h2 {
  margin-bottom: 1rem;
}
h2 small {
  margin-left: 2rem;
}
.results, .no-results, .loading {
  margin-top: 2rem;
}
.results ul {
  margin-top: 2rem;
}
.results li {
  font-size: 1.2rem;
  margin-top: 0.5rem;
}
.no-results {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// ApiResult.vue?6ae2a26e